<template>
  <layout>
    <section class="demand-main">

      <!-- START Search Box -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-body">
              <div class="row">
<!--                <div class="col-xl-3 col-lg-6">
                  <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                                label="사업자" label-for="searchBusiness"
                                label-cols="3" content-cols="9">
                    <multiselect id="searchBusiness"
                                 v-model="searchForm.busiId"
                                 :options="businessOptions"
                                 label="text" placeholder="" select-label=""
                                 :allow-empty="false" deselect-label=""
                                 :max-height="202" @input="search">
                      <span slot="noResult">No Result</span>
                    </multiselect>
                  </b-form-group>
                </div>-->
                <div class="col-xl-3 col-lg-6">
                  <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                                label="조회 월" label-for="searchMonth"
                                label-cols="3" content-cols="9">
                    <date-picker id="searchMonth" v-model="searchForm.month"
                                 type="month" value-type="YYYY-MM" append-to-body lang="ko"
                                 :disabled-date="disabledAfterToday" @input="search" />
                  </b-form-group>
                </div>
<!--                <search-buttons layout-class="col-xl-6 ct-margin-top-25"-->
<!--                                resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                                :reset-fn="reset" :search-fn="search" />-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Search Box -->

      <!-- START Middle Area -->
      <div class="row">

        <!-- START Middle Left Area -->
        <div class="col-xl-4">
          <div class="card shadow card-height-100">
            <div class="card-body">
              <card-title icon-image="mdi-office-building-marker" title="충전소" text-color="title" />
              <div class="station-list-table">
                <b-table class="datatables text-nowrap"
                         :tbody-tr-class="rowClass"
                         :fields="stationFields" :items="stationItems">
                  <template #cell(placeName)="data">
                    <a href="javascript: void(0);" @click="viewStation(data.item)">
                      <span :title="`${data.item.placeName}`">{{ $_utils.textLengthOverCut(data.item.placeName, 10, '') }}</span>
                    </a>
                  </template>
                  <template #cell(totEnergy)="data">
                    <span>{{ $_utils.comma(data.item.totEnergy) }}</span>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <!-- END Middle Left Area -->

        <!-- START Middle Right Area -->
        <div class="col-xl-8">
          <!-- // Demand Resource Info -->
          <div class="card shadow">
            <div class="card-body">
              <card-title icon-image="mdi-google-circles-extended" text-color="title" sub-text-color="main-green"
                          title="충전소 수요자원 정보" :sub-title="`${searchForm.station.placeName}`" />
              <div class="row">
                <div class="col-xl-6">
                  <div class="demand-resource-list-table">
                    <b-table class="datatables text-nowrap"
                             :fields="demandResourceFields" :items="demandResourceItems">
                      <template #cell(peakDemand)="data">
                        <span>{{ $_utils.comma(data.item.peakDemand) }}</span>
                        <span class="ct-text-muted font-size-12"> kW</span>
                      </template>
                    </b-table>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="ct-mb-margin-top-100" style="padding: 0 20px">
                    <div class="item-box">
                      <span class="item-title">DR 참여 횟수</span>
                      <span class="item-value">0 회</span>
                    </div>
                    <div class="item-box mt-4">
                      <span class="item-title">계약 용량</span>
                      <span class="item-value">{{ capacity }} kW</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- // Station Charge Power -->
          <div class="card shadow">
            <div class="card-body">
              <card-title icon-image="mdi-chart-line" title="충전소 충전량 (15분)" text-color="title" />
              <div id="charts" class="border p-1">
                <div id="chart-area1">
                  <apexchart ref="groupChart1" type="area" height="160"
                             :options="chartOptionsArea" :series="chartOptionsArea.series" />
                </div>
                <div id="chart-area2">
                  <apexchart ref="groupChart2" type="area" height="120"
                             :options="chartOptionsBrush" :series="chartOptionsBrush.series" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Middle Right Area -->

      </div>
      <!-- END Middle Area -->

      <!-- START Bottom Area -->
      <div class="row">

        <!-- // Station Info -->
        <div class="col-xl-4">
          <div class="card shadow">
            <div class="card-body">
              <card-title icon-image="mdi-office-building-marker" text-color="title" sub-text-color="main-green"
                          title="충전소" :sub-title="`${searchForm.station.placeName}`" />
              <div class="station-basic-info">
                <div class="row">
                  <div class="col-12 info-content">
                    <span class="mdi mdi-record ct-text-muted icon-padding-right-50"></span>
                    <span>{{ searchForm.station.address }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 info-content">
                    <span class="mdi mdi-record ct-text-muted icon-padding-right-50"></span>
                    <span v-if="!$_utils.isEmpty(searchForm.station.dongCount)">
                      {{ searchForm.station.dongCount }} 개동 / {{ $_utils.comma(searchForm.station.houseCount) }} 세대
                    </span>
                  </div>
                  <div class="col-6 info-content">
                    <span class="mdi mdi-record ct-text-muted icon-padding-right-50"></span>
                    <span>수전 용량: {{ $_utils.comma(searchForm.station.totEnergy) }} kW</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 info-content">
                    <span class="mdi mdi-record ct-text-muted icon-padding-right-50"></span>
                    <span>승인: {{ $_utils.isEmpty(searchForm.station.approvalDate) ? '-' : searchForm.station.approvalDate }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 info-content">
                    <span class="mdi mdi-record ct-text-muted icon-padding-right-50"></span>
                    <span>{{ searchForm.station.elecMethod }}</span>
                  </div>
                  <div class="col-6 info-content">
                    <span class="mdi mdi-record ct-text-muted icon-padding-right-50"></span>
                    <span>{{ searchForm.station.mntMethod }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- // Station Status -->
        <div class="col-xl-8">
          <div class="card shadow card-height-100">
            <div class="card-body">
              <card-title icon-image="mdi-table-large" text-color="title" title="실시간 충전소 현황" />
              <div class="real-time-evse-table">
                <b-table class="datatables text-nowrap" show-empty empty-text="No Data"
                         :fields="realTimeEvseFields" :items="realTimeEvseItems">
                  <template #cell(evseName)="data">
                    <span>{{ data.item.speed }}  {{ data.item.chgerId }}</span>
                  </template>
                  <template #cell(output)="data">
                    <span>{{ getOutputTitle(data.item) }}</span>
                  </template>
                  <template #cell(status)="data">
                    <span :class="`${getEvseStatusColor(data.item)}`">{{ getEvseStatusTitle(data.item) }}</span>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>

        <!-- // Evse Use Rate -->
<!--        <div class="col-xl-4">
          <div class="card shadow card-height-100">
            <div class="card-body">
              <card-title icon-image="mdi-chart-bar" title="최근 충전기 이용률" text-color="title" />
              <div class="border p-2">
                <apexchart ref="stationUtzChart" height="186" :options="chargerUtzChartOptions"
                           :series="chargerUtzChartOptions.series"/>
              </div>
            </div>
          </div>
        </div>-->
      </div>
      <!-- END Bottom Area -->

    </section>
  </layout>
</template>

<script>
import Layout from '@/views/layouts/main.vue';
import Multiselect from 'vue-multiselect';
import CardTitle from '@/views/components/cardTitle.vue';
import SearchButtons from "@/views/components/searchButtons.vue";

export default {
  components: { SearchButtons, Layout, Multiselect, CardTitle },
  data() {
    return {
      businessOptions: [
        { value: 'GN', text: '지커넥트' },
      ],
      searchForm: {
        busiId: { value: 'GN', text: '지커넥트' },
        month: "2024-01",//moment().subtract(2, 'months').format('YYYY-MM'),
        station: {}
      },
      stationFields: [
        { key: 'custNo', label: '한전 고객번호', sortable: true },
        { key: 'placeName', label: '충전소', sortable: true },
        { key: 'evseCount', label: '충전기', sortable: true },
        { key: 'totEnergy', label: '월 충전량 (kWh)', sortable: true }
      ],
      stationItems: [],
      demandResourceFields: [
        { key: 'meterDate', label: '발생 일자' },
        { key: 'peakDemand', label: '최대 수요 전력' }
      ],
      demandResourceItems: [],
      chartOptionsArea: {
        chart: {
          id: 'chart1',
          toolbar: {
            show: false
          }
        },
        colors: ['#546E7A'],
        stroke: {
          curve: 'straight',
          width: 2
        },
        dataLabels: { enabled: false },
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.91,
            opacityTo: 0.1
          }
        },
        markers: { size: 0 },
        xaxis: {
          type: 'datetime',
          labels: {
            format: 'MM/dd'
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            formatter: function(val, index) {
              return Number(val).toLocaleString();
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd HH:mm'
          },
          y: {
            title: {
              formatter: (seriesName) => '충전량'
            },
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return value + ' kW'
            }
          }
        },
        series: [
          {
            data: []
          }
        ]
      },
      chartOptionsBrush: {
        chart: {
          id: 'chart2',
          brush: {
            target: 'chart1',
            enabled: true
          },
          selection: {
            enabled: true
          }
        },
        colors: ['#008FFB'],
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.91,
            opacityTo: 0.1
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            format: 'MM/dd'
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 2
        },
        series: [
          {
            data: []
          }
        ]
      },
      chargePowerItems: [],
      realTimeEvseFields: [
        { key: 'evseName', label: '충전기' },
        { key: 'output', label: '용량' },
        { key: 'status', label: '상태' }
      ],
      realTimeEvseItems: [],
      capacity: 0,
      chargerUtzChartOptions: {
        series: [],
        chart: {
          type: 'bar',
          offsetY: -5,
          parentHeightOffset: 0,
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: {
          categories: Array.from({ length: 24 }, (v, i) => i),
          tickPlacement: 'on',
          labels: {
            maxHeight: 10,
            hideOverlappingLabels: false,
            offsetY: -5,
            style: { fontSize: ' 0.5rem' }
          },
          axisTicks: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: {
          tickAmount: 2,
          max: max => {
            if (max >= 70 || max === 0) return 100;
            else if (max <= 10) return max + 2;
            else return max + 5;
          },
          labels: {
            show: true,
            minWidth: 0,
            maxWidth: 14,
            style: {
              fontSize: ' 0.5rem',
            },
            formatter: val => val.toFixed(0),
          }
        },
        noData: {
          text: 'Loading...',
          style: { fontSize: '12px' }
        },
        colors: ['#be0052'],
        fill: { opacity: 1 },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '40%'
          }
        },
        tooltip: {
          enabled: true,
          x: { show: false },
          y: {
            formatter: val => `${val} %`,
            title: {
              formatter: (val, opts) =>
                  `${opts.w.globals.labels[opts.dataPointIndex] -1 }시`
            }
          },
        }
      },
      realTimeEvseUtz: []
    }
  },
  created() {
    const vm = this;
    vm.search();
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      return date > new Date(today.setMonth(today.getMonth()-1));
    },
    // reset() {
    //   const vm = this;
    //
    //   vm.searchForm = {
    //     busiId: { value: 'GN', text: '지커넥트' },
    //     month: new Date(moment().subtract(1, 'months').format('YYYY-MM')),
    //     station: {}
    //   };
    // },
    search() {
      const vm = this;
      vm.getStationItems();
    },
    getStationItems() {
      const vm = this;
      const _url = '/onmapi/aptinfo/detail/gnplace-info';
      const _targetMonth = vm.searchForm.month;

      this.$axios.get(_url, {
        params: {
          targetMonth: _targetMonth
        }
      }).then((res) => {
        vm.stationItems = res.data.items;

        vm.$nextTick(()=> {
          vm.viewStation(vm.stationItems[0])
        });
      }).catch(err => {
        console.error('Station List Error :: ', err)
      });
    },
    viewStation(item) {
      const vm = this;
      vm.searchForm.station = Object.assign({}, item);

      this.$nextTick(() => {
        vm.getDemandResourceInfo();
        vm.getChargePower();
        vm.getRealTimeEvseStatus();
      });
    },
    getDemandResourceInfo() {
      const vm = this;
      const _url = '/onmapi/aptinfo/detail/gnmeter/peak';
      const _targetMonth = vm.searchForm.month;

      this.$axios.get(_url, {
        params: {
          placeId: vm.searchForm.station.placeId,
          targetMonth: _targetMonth
        }
      }).then((res) => {
        vm.demandResourceItems = res.data;
      }).catch((err) => {
        console.error('Demand Resource Info Data Error !!', err)
      });
    },
    getChargePower() {
      const vm = this;
      const _url = '/onmapi/aptinfo/detail/gnmeter/chart';

      const _startDate = moment(vm.searchForm.month).startOf('month').format('YYYY-MM-DD');
      const _endDate = moment(vm.searchForm.month).endOf('month').format('YYYY-MM-DD');
      const _selectionMax = moment(_startDate).add(6, 'day').format('YYYY-MM-DD');

      this.$axios.get(_url, {
        params: {
          placeId: vm.searchForm.station.placeId,
          startDate: _startDate,
          endDate: _endDate
        }
      }).then((res) => {
        vm.chargePowerItems = [];

        res.data.items.forEach((data, i) => {
          let temp = [data.meterDateLongVal*1000, data.meterValue];

          vm.chargePowerItems.push(temp);
        })

        vm.$refs.groupChart1.updateSeries([{
          data: vm.chargePowerItems
        }]);

        vm.$refs.groupChart2.updateOptions(
            {
              chart: {
                selection: {
                  xaxis: {
                    min: new Date(_startDate).getTime(),
                    max: new Date(_selectionMax).getTime()
                  }
                }
              }
            }, true
        );

        vm.$refs.groupChart2.updateSeries([{
          data: vm.chargePowerItems
        }]);
      }).catch((err) => {
        console.error('Station Charge Power Data Error !!', err)
      });
    },
    getRealTimeEvseStatus() {
      const vm = this;
      const _url = `/me/apt/${vm.searchForm.station.placeId}`;

      this.$axios.get(_url).then((res) => {
        vm.realTimeEvseItems = res.data !== null ? res.data.evse : [];

        vm.capacity = 0;
        vm.realTimeEvseItems.forEach((data, i) => {
          if (data.output < 1) {
            vm.capacity += data.speed === '완속' || data.speed === 'ac' ? 7 : 50;
          } else {
            vm.capacity += data.output;
          }
        })

        vm.realTimeEvseUtz = res.data !== null ? res.data.utz : [];

        this.$refs.stationUtzChart.chart.updateSeries([{ name: '충전소 이용률', data: vm.realTimeEvseUtz }]);
      }).catch((err) => {
        console.error('Real Time Station Status Data Error !!', err)
      });
    },
    getOutputTitle(item) {
      let title = item.output;

      if (item.output < 1) {
        title = item.speed === '완속' || item.speed === 'ac' ? 7 : 50;
      }

      return title;
    },
    getEvseStatusTitle(item) {
      switch (item.status) {
        case 1: return '충전가능';
        case 2: return '충전중';
        case 3: return '고장/점검';
        default: return '상태 미확인';
      }
    },
    getEvseStatusColor(item) {
      switch (item.status) {
        case 1: return 'ct-text-evse-possible';
        case 2: return 'ct-text-evse-charging';
        case 3: return 'ct-text-evse-operation-stop';
        default: return 'ct-text-evse-uncheck';
      }
    },
    rowClass(item, type) {
      const vm = this;
      if (!item || type !== 'row') return;
      if (item.placeId === vm.searchForm.station.placeId) return 'tr-active';
    }
  }
}
</script>
